import React, { useState, useEffect } from "react";
import styles from "../../styles/components/offering.module.scss";
import Link from "next/link";

import _get from "lodash/get";

import endpoints from "../../utility/endpoints";

import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import OfferingBanner from '../OfferingBanner/OfferingBanner.jsx';



function index(props) {
 
 
  //console.log(props, "propsatoffer123");




  

  return (

    <div className = {styles.offeringParent}>
  
    
     <OfferingBanner
     
     data = {{
    field_background_image : `${endpoints.drupalIp}${props.data[0].component.content.field_background_image[0].file_url}`,
    field_hedaing : _get(props,"data[0].component.content.field_hedaing",""),
    field_details : _get(props,"data[0].component.content.field_details",""),
    field_background_mobile : `${endpoints.drupalIp}${props.data[0].component.content.field_background_image_mobile[0].file_url}`
  }}
    
    />
    
    


    <div className={styles.heximages}>
      <div className="container">
        <div className={styles.title}>
          Automation Offerings
        </div>
        <div className={`${styles.hexImage} d-flex justify-content-center`}>
          <div className={`${styles.imagesAlign} row`}>
            <div className={styles.Image}>
            {(_get(props,"data[1].component.content.field_offerings_content",[])).map((item,index)=>
<Link href={item.field_title == "Catalogue Products" ? "/catalogue-products"
            :item.field_title == "Touchless Processes" ? "/touchless-processes"
            : item.field_title == "Profile Automation" ? "/profile-automation"
            : item.field_title == "Organic Demand" ? "/organic-demand"
            : item.field_title == "Intelligent Applications" ? "/intelligent-applications" : "/404"}>   
              <div className={styles.hexCard}  key={index} >
                <div className={styles.hex}>
                  <div className={styles.border}>
                    <img src={`${endpoints.drupalIp}${item.field_offerings_image[0].file_url}`} alt="" />
                  </div>
                </div>
                <span>{item.field_title}</span>
              </div>
              </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
